import {createPersister} from '@github-ui/react-query-persister'
import {Compile} from '@github-ui/react-query-persister/typebox/compile'
import {ReviewRequestsDataSchema} from '../page-data/payloads/review-requests'
import type {QueryPersister} from '@github-ui/react-query'
import {sendEvent} from '@github-ui/hydro-analytics'
import type {SendAnalyticsEventFunction} from '@github-ui/use-analytics'

const ReviewRequestsValidator = Compile(ReviewRequestsDataSchema)

// Wrap hydro-analytics sendEvent to match the SendAnalyticsEventFunction signature
// expected by createPersister. This avoids requiring React context (useAnalytics)
// since this persister is used in a route definition, not inside a component.
const sendAnalyticsEvent: SendAnalyticsEventFunction = (eventType, target?, payload = {}) => {
  sendEvent(eventType, {...payload, target, react: true, app_name: 'pull-requests'})
}

export const reviewRequestsPersister: QueryPersister = (queryFn, ctx, query) => {
  const persister = createReviewRequestsPersister()
  return persister(queryFn, ctx, query)
}

export function createReviewRequestsPersister() {
  return createPersister({
    validator: ReviewRequestsValidator,
    sendAnalyticsEvent,
    enabled: true,
  })
}
